<template>
  <div class="main-container">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <!-- breadcrumb -->
    <div class="row">
      <div class="col-4">
        <div class="employee-card">
          <div>
            <img src="@/assets/user.svg" alt="actionIcon" />
          </div>
          <div class="card-details">
            <h4>Roxie Schmidt</h4>
            <p class="code">RC1234</p>
            <p>Effective from Aug 2019</p>
            <hr />
            <div class="row margin-t-s margin-b-s">
              <div class="col-6">Potential</div>
              <div class="col-6">Rs. 447503</div>
              <div class="col-6">Actual</div>
              <div class="col-6">Rs. 171042</div>
              <div class="col-6">Gap</div>
              <div class="col-6">Rs. 276460</div>
            </div>
            <hr />
            <p></p>
            <p>Taxable Income : Rs 712783</p>
            <p>Annual Tax: Rs 712783</p>
          </div>
        </div>
      </div>
      <div class="col-8" v-if="$route.query.status == 'uploaded'">
        <div class="successCard">
          <div class="success-img">
            <div class="circle">
              <img src="@/assets/circle.svg" />
            </div>
            <div class="tick">
              <img src="@/assets/tick.svg" />
            </div>
          </div>
          <p class="align-center">You have succesfully sunmitted Roxie's IT Declaration plan</p>
          <p class="align-center">
            <a href="javascript:void(0)" @click="editPlan()">Edit Plan</a>
          </p>
        </div>
      </div>
      <div class="col-8" v-if="$route.query.status == 'download'">
        <div class="successCard">
          <div class="row">
            <div class="col-8">
              <div class="success-sm-img">
                <span class="circle">
                  <img src="@/assets/circle.svg" />
                </span>
                <span class="tick">
                  <img src="@/assets/tick.svg" />
                </span>
                <span
                  class="success-text"
                >You have succesfully sunmitted Roxie's IT Declaration plan</span>
              </div>
            </div>
            <div class="col-4 align-right">
              <a href="javascript:void(0)" class="edit-link" @click="back()">Edit your Plan</a>
            </div>
          </div>
          <hr class="horizontal-line" />
          <div class="row margin-t-s">
            <div class="col-12 d-heading margin-l-xxl">Final Step for submission</div>
            <div class="col-12 margin-l-xxl">
              <p>Download following forms, reupload them after self-declaration by Roxie</p>
              <div class="margin-t-m">
                <span class="download-button">
                  <a href="javascript:void(0)">
                    Form 12BB
                    <img src="@/assets/download.svg" alt />
                  </a>
                </span>
                <span class="download-button">
                  <a href="javasript:void(0)">
                    House Rent Allowence
                    <img src="@/assets/download.svg" alt />
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn
            text="Upload and Submit"
            v-if="$route.query.status != 'uploaded'"
            type="primary"
            @click="goToUpload()"
          />
          <btn
            text="Back to Employee List"
            v-if="$route.query.status == 'uploaded'"
            type="secondary"
            @click="backToEmployee()"
          />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { monthOptionsObj } from "../../../../../../../apis/constants.js";
export default {
  data() {
    return {
      optionsData: [
        "All",
        "Previous Tax",
        "Section 10",
        "Rent Details",
        "Investments",
        "Others"
      ],
      months: monthOptionsObj.onlyMonths,
      submissionStartMonth: "",
      submissionStartDay: "",
      submissionEndMonth: "",
      declarationStartMonth: "",
      errmsg: "",
      toast: false
    };
  },
  activated() {
    this.fetchitsettings();
  },
  computed: {
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    }
  },
  methods: {
    ...mapActions({
      fetch_it_settings: "onboard/statutoryinfo/incometax/fetchAll"
    }),

    async fetchitsettings() {
      try {
        let res = await this.fetch_it_settings(this.le_id);
        let obj = res.data.payload.data;
        let d1 = new Date(obj.submissionSettings.submissionStartDate);
        let d2 = new Date(obj.submissionSettings.submissionEndDate);
        this.submissionStartMonth = d1.getMonth();
        this.submissionEndMonth = d2.getMonth();
        this.declarationStartMonth = this.months.indexOf(
          obj.declarationSettings.declarationStartMonth
        );
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    back() {
      this.$router.go(-1);
    },
    backToEmployee() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/ITdeclarations`
      });
    },
    editPlan() {
      try {
        let date = new Date();
        let currentMonth = date.getMonth();
        let currentDay = date.getDate();
        if (
          this.submissionStartMonth >= currentMonth &&
          currentDay >= this.submissionStartDay &&
          currentMonth <= this.submissionEndMonth
        ) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/editActualdeclaration`,
            query: { id: this.$route.query.id }
          });
        }
        if (
          this.declarationStartMonth <= currentMonth &&
          currentMonth <= this.submissionStartMonth &&
          currentDay <= this.submissionStartDay
        ) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/editdeclaration`,
            query: { id: this.$route.query.id }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    goToUpload() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/exportdeclarations`,
        query: { id: this.$route.query.id }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container-width {
  width: 300px;
}
.employee-card {
  display: grid;
  grid-template-columns: 50px auto;

  grid-gap: 18px;
  max-width: 400px;
  opacity: 0.8;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  padding: 23px;
  img {
    width: 55px;
    height: 55px;
    opacity: 0.8;
    border-radius: 41px;
  }
  .card-details {
    .code {
      margin-bottom: 2px;
      color: #979797;
      font-size: 12px;
    }
    p {
      margin-bottom: 5px;
    }
    .year-data {
      font-size: 14px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: normal;
      color: #535353;
    }
  }
}
.download-button {
  margin-right: 20px;
  background-color: #f5f5f5;
  padding: 10px;
  a {
    text-decoration: none;
    color: #535353;
    font-weight: 500;
  }
}
.horizontal-line {
  margin-left: 35px;
  margin-right: 35px;
  border-top: 1px solid #ddd;
}
.successCard {
  border-radius: 10px;
  border: solid 1px #cccfce;
  height: 230px;
}
.edit-link {
  position: relative;
  top: 20px;
  padding-right: 35px;
  color: #5d409f;
}
.success-sm-img {
  position: relative;
  left: 50px;
  margin-top: 15px;
  margin-bottom: 15px;
  .circle {
    position: relative;
    img {
      width: 25px;
    }
  }
  .tick {
    position: absolute;
    bottom: 7px;
    left: 5px;
    img {
      width: 15px;
    }
  }
  .success-text {
    position: relative;
    top: -7px;
    left: 10px;
  }
}
.success-img {
  position: relative;
  margin-left: 45%;
  margin-top: 5%;
  .circle {
    position: relative;
    left: 10px;
    height: 80px;
    width: 80px;
  }
  .tick {
    position: absolute;
    bottom: 21px;
    left: 17px;
    width: 45px;
    height: 45px;
  }
}
</style>


